import React from "react";
import Sidebar from "../reusable/Sidebar.jsx";
import parse from "html-react-parser";
import axios from "axios";
const GLOBAL = require('../../commonConstants.js');
const url = GLOBAL.BASE_URL + "MasterClassMappings";
const assetUrl = GLOBAL.assetUrl;


function MasterClasses() {
  const [getMasterClasses, setMasterClasses] = React.useState(null);

  const agendaFileById = {
    10: "ISUW2026MasterClassAgenda2026.pdf",
    1: "Sno1ISUW2024Agenda_Masterclass.pdf",
    2: "Sno2ISUW2023Agenda_Masterclass.pdf",
    3: "Sno3ISUW2020Agenda_masterclass.pdf",
    4: "Sno4ISUW2020Agenda_masterclass.pdf",
    5: "Sno5ISUW2020Agenda_masterclass.pdf",
    6: "Sno6ISUW2020Agenda_masterclass.pdf",
    7: "Sno7ISUW2019Agenda_Masterclass.pdf",
    8: "Sno8ISUW2019Agenda_Masterclass.pdf",
    9: "Sno9ISUW2019Agenda_Masterclass.pdf",
    15: "Sno15ISGW2017AGENDA_Masterclass.pdf",
  };

  const toDocumentUrl = (fileName) => {
    if (!fileName) return null;
    const noSpaceFileName = fileName.replace(/\s+/g, "");
    return `${assetUrl}/public/uploads/documents/${encodeURIComponent(noSpaceFileName)}`;
  };

  const getAgendaHref = (item) => {
    if (!item) return null;
    if (item.agenda_link) return item.agenda_link;

    if (item.agenda_file) {
      if (item.agenda_file.startsWith("http")) return item.agenda_file;
      return toDocumentUrl(item.agenda_file);
    }

    if (item.agenda && typeof item.agenda === "string") {
      if (item.agenda.startsWith("http")) return item.agenda;
      if (/\.(pdf|doc|docx|ppt|pptx)$/i.test(item.agenda)) {
        return toDocumentUrl(item.agenda);
      }
    }

    return toDocumentUrl(agendaFileById[item.id]);
  };

  // Static data based on the Word document content
  const staticMasterClasses = [
    {
      id: 10,
      title: "ISUW 2026 | MASTER CLASS ON AGENTIC AI - HOW TO BUILD AND DEPLOY AI AGENTS",
      description: `
        <p>The world has seen the evolution of artificial intelligence over many decades, from Turing test in the 1950s to Generative AI in 2020s and is now witnessing a paradigm shift from "Generative" to "Agentic" Artificial Intelligence. Unlike its predecessors, which are used to analyze, create text, and make decisions, Agentic AI is able to execute tasks with minimal human interventions. These systems plan, act, and adapt independently, operating as digital teammates that can handle repetitive tasks while humans focus on strategic decision-making.</p>
        <p>In the power sector, Agentic AI can be deployed to make proactive decisions, pursue goals, and adapt to changing conditions, initiating actions and learning from outcomes without human prompts. For instance, a utility control system that spots an equipment anomaly before it triggers an outage. Within seconds, it creates a work order in the Enterprise Resource Platform (ERP), dispatches a nearby field crew, re-routes the load to stabilize supply, and sends customers a proactive message about restoration timelines - all autonomously and transparently. Autonomous AI agents can perform critical functions such as Billing and Collections, Grid and Outage Management, and Customer Experiences.</p>
        <p>Building these agents requires a new cognitive architecture, which fundamentally consists of three components: the "Brain", "Memory", and "Tools". This session explores the benefits, challenges, responsible AI practices, importance of Small Language Models (SLMs), and how to build agents and strategies to deploy them.</p>
        <p><strong>Course Contents:</strong></p>
        <ol>
          <li>Benefits of Agentic AI over Gen AI for utilities and business case for giving AI "hands" to execute tasks</li>
          <li>Differentiation of LLMs, SLMs and LAMs, and how agentic models offer localized efficient solutions and support Indian languages</li>
          <li>Different layers of Agentic Memory - STM, LTM and feedback loops</li>
          <li>Real-world use cases of Agentic AI in power sector domain</li>
          <li>Secure APIs that allow agents to interact with CIS, GIS, ERP, and CRM systems</li>
          <li>Strategies to build and deploy agents and economic benefits for utilities</li>
        </ol>
        <p><strong>Tutors:</strong></p>
        <ul>
          <li>Mukesh Kala, Hyper Automation Practice Head, Boundaryless Group</li>
          <li>Shalabh Gupta, CEO and Co-founder, Sidhhanth</li>
          <li>Manoj Batra, Vice President - RPA, NatWest Group</li>
          <li>Arani Chaudhuri, Founder and CEO, AI Library</li>
        </ul>
      `,
      date: "10 March 2026",
      location: "Hotel The Lalit, New Delhi",
      photos: "https://flic.kr/s/aHBqjCNat9",
      videos: [
        "https://youtu.be/Fk2Wd8PMWZc?si=DjG0zgMDgROU79lY",
        "https://youtu.be/QhUHkU0QS0Q?si=nlYDm7P4FoFU7RSe"
      ],
      agenda: "Agenda"
    },
    {
      id: 1,
      title: "ISUW 2024 | MASTER CLASS ON ENERGY TRANSITION STRATEGIES AND PATHWAYS TO NET ZERO POWER SYSTEMS",
      description: `
        <p>The utility industry value chain was undergoing a major transformation and transition. Driven by regulatory, policy, business, technology, and the consumer, change was being wrought in all aspects of the value chain. This energy transition drove standards, codes, new technologies, and new investments. It also led to the emergence of disruptive technologies. The aim of this tutorial was to first define energy transition to net-zero, discussed the drivers, enablers, barriers, and mapped out the current state and the future state. This transition was viewed from the prism of enablers like DER/renewables, next generation in smart sensors (including smart meters), blockchain, and consumer/prosumer engagement in local markets to monetize the benefits, along with other enabling technologies and cybersecurity in this future state. The tutorial then pivoted to the application of these technologies to the modern utility industry and how this helped in initiating new transformation opportunities or aided in completing existing initiatives. This tutorial also sought to bring out the value to all the key stakeholders – Government, the regulator, the policy maker, market, the utility, and the prosumer – as it pursued new business models to monetize new and existing services.</p>
        
        <p><strong>Discussion Points:</strong></p>
        <ol type="a">
          <li><strong>Energy Transition to Net Zero – An Overview:</strong> Driven by regulatory, policy, prosumer, and ongoing technological innovation; the energy transition to net zero was in progress. In this section, we reviewed the current trends in the industry and set the stage to discuss the current state and future state of this transition with relevant applications.</li>
          <li><strong>Key Stakeholders and their roles:</strong> The main stakeholders in this energy transition were Government, policy makers, regulators (Federal and regional level), advisors, consumer advocates, utilities, and the consumer/prosumer. We discussed the enablers, barriers, support structures, and such in this space and evaluated their impact on the energy transition.</li>
          <li><strong>Current State – A Global Perspective:</strong> The global and North American current state was discussed</li>
          <li><strong>The Future State – Vision, Mission & Architecture:</strong> The vision for the future state was one that was smart, dynamic, and adaptive, driven by digitalized systems. The future multi-directional system was discussed in this section.
            <ul>
              <li>Systems</li>
              <li>Services (like Ancillary Services)</li>
              <li>Data Flow and Models</li>
              <li>Architecture</li>
            </ul>
          </li>
          <li><strong>Technologies - The Key Enabler (DER, EV, DR/ DSM, Blockchain, AMI etc.,)</strong>
            <ul>
              <li>Next Generation in AMI & Analytics</li>
              <li>Orchestration (DERMS, DRMS, and edge monitoring and dispatch)</li>
              <li>Blockchain technology and consumer/ prosumer participation in local markets, microgrids, EV/ DER and monetization</li>
            </ul>
          </li>
          <li>Case Studies and Examples</li>
          <li>Conclusion and Q/A</li>
        </ol>
        
        <p><strong>Tutors:</strong></p>
        <ul>
          <li>Mani Vadari, Founder and President, Modern Grid Solutions (Virtual)</li>
          <li>Anant Venkateswaran, Industry Professional, ISGF and Hitachi Energy</li>
          <li>Rahul Tongia, Senior Fellow- CSEP, Founding Advisor-ISGF</li>
          <li>Reji Kumar Pillai, President, ISGF</li>
        </ul>
      `,
      date: "12 March 2024",
      location: "Hotel The Lalit, New Delhi",
      photos: "https://flic.kr/s/aHBqjBimtp",
      videos: [
        "https://youtu.be/MJFHzR64iPw?si=Ri1akAaysKJu3LLB",
        "https://youtu.be/ySKhGqZYGMI?si=BmRsLZysfOdU2o6E"
      ],
      agenda: "More Details"
    },
    {
      id: 2,
      title: "ISUW 2023 | ENERGY TRANSITION TO NET ZERO POWER SYSTEM -- STRATEGIES AND PATHWAYS",
      description: `
        <p>The aim of this tutorial was to define an outline for the energy transition pathways of power systems to Net Zero so that countries could achieve their Net Zero targets. This Master Class, certified by IEEE Education, covered the global and Indian perspectives on choices for energy transition pathways and strategies.</p>
        <p><strong>Discussion Points:</strong></p>
        <ol type="a">
          <li>Energy Transition to Net Zero -- An Overview</li>
          <li>Key Stakeholders and Their Roles</li>
          <li>Current State -- Global and Indian Perspectives</li>
          <li>The Future State -- Vision and Pathways</li>
          <li>DER's - Dispatching Grid Scale DER's</li>
          <li>Technologies - The Key Enablers</li>
          <li>The Consumer/ Prosumer</li>
          <li>Integrating Security and Privacy into the Evolving Net Zero Energy Ecosystem Across the Value Chain</li>
          <li>Case Studies and Examples</li>
        </ol>
        <p><strong>Tutors:</strong></p>
        <ul>
          <li>Anant Venkateswaran, Industry professional, ISGF and Hitachi Energy</li>
          <li>Mani Vadari, Founder and President, Modern Grid Solutions</li>
          <li>Reji Kumar Pillai, President, ISGF</li>
          <li>Rahul Tongia, Senior Fellow, CSEP</li>
          <li>Stefan Tenbohlen, Head of Institute of Energy Transmission and High Voltage Engineering, University of Stuttgart</li>
          <li>Andrew Ginter, VP-Industrial Security, Waterfall Security Solutions</li>
        </ul>
      `,
      date: "28 FEBRUARY 2023",
      location: "Hotel The Lalit, New Delhi",
      photos: "https://flic.kr/s/aHBqjAvhYH",
      videos: [
        "https://youtu.be/ff7IzZzvNY4?si=HAPtT4ATpOEZsns4",
        "https://youtu.be/LMSBuGsDqA4?si=L8GHlRICkLClMgwO"
      ],
      agenda: "More Details"
    },
    {
      id: 3,
      title: "ISUW 2020 | TRACK-1: TECHNOLOGIES ENABLING ENERGY TRANSITION: DIGITALIZATION",
      description: `
        <p>Energy transition was a pathway towards the transformation of the global energy sector from fossil-based to zero-carbon, and digitalization facilitated this transformation story through the use of information and communication technology.</p>
        <p><strong>Session 1:</strong></p>
        <ol>
          <li>Digital Consumers</li>
          <li>AMI and Utility Transformation -- Different Use Cases</li>
          <li>Asset Management through Advance Analytics</li>
        </ol>
        <p><strong>Tutors:</strong> Anant Venkateswaran (ISGF), Ajoy Rajani (ISGF)</p>
        <p><strong>Session 2:</strong></p>
        <ol>
          <li>Cybersecurity in the Digital Age</li>
          <li>Cloud -- The Enabler for Digitalization</li>
          <li>An Introduction to AI, Machine Learning, and Big Data and their Impacts on the utility</li>
          <li>Unlocking the "Fifth Fuel" - Increased Energy Efficiency with Machine Learning and Big Data</li>
        </ol>
        <p><strong>Tutors:</strong> Andrew Ginter (VP, Industrial Security at Waterfall Security Solutions, Canada), Anant Venkateswaran (ISGF)</p>
      `,
      date: "03 MARCH 2020",
      location: "Hotel The Lalit, New Delhi",
      photos: "https://flic.kr/s/aHsmM7aCM1",
      videos: null,
      agenda: "More Details"
    },
    {
      id: 4,
      title: "ISUW 2020 | TRACK-2: TECHNOLOGIES ENABLING ENERGY TRANSITION: E-MOBILITY",
      description: `
        <p>This course covered EV policies and programs in India vis-a-vis those of leading countries in the world, and included an introduction to EV charging infrastructure, standards, and communication technologies.</p>
        <p><strong>Session 1:</strong></p>
        <ol>
          <li>Global EV Deployment</li>
          <li>EV Technologies</li>
          <li>International Best Practices</li>
        </ol>
        <p><strong>Tutors:</strong> Girish Ghatikar (Senior Program Manager- EPRI, California, USA, and Chair of ISGF Working Group)</p>
        <p><strong>Session 2:</strong></p>
        <ol>
          <li>Electric Vehicle Charging Infrastructure</li>
          <li>Vehicle to Grid Integration</li>
          <li>Enhancement and Health Management</li>
        </ol>
        <p><strong>Tutors:</strong> Lonneke Driessen-Mutters (Executive Director, Open Charge Alliance), Reji Kumar Pillai (President, India Smart Grid Forum)</p>
      `,
      date: "03 MARCH 2020",
      location: "Hotel The Lalit, New Delhi",
      photos: "https://flic.kr/s/aHsmMa1YHD",
      videos: null,
      agenda: "More Details"
    },
    {
      id: 5,
      title: "ISUW 2020 | TRACK-3: ADVANCED CYBER SECURITY",
      description: `
        <p>Security became a crucial factor for the success and wide deployment of smart grid networks. A cyber-attack on the power grid could have resulted in complete disruption of all activities in society.</p>
        <p><strong>Session 1:</strong></p>
        <ol>
          <li>Attack Patterns</li>
          <li>Defenses and Their Limitations</li>
        </ol>
        <p><strong>Tutors:</strong> Andrew Ginter (VP, Industrial Security at Waterfall Security Solutions, Canada)</p>
        <p><strong>Session 2:</strong> Designs for High-Threat Environments</p>
        <p><strong>Tutors:</strong> Andrew Ginter (VP, Industrial Security at Waterfall Security Solutions, Canada)</p>
      `,
      date: "03 MARCH 2020",
      location: "Hotel The Lalit, New Delhi",
      photos: "https://flic.kr/s/aHsmM9TrAq",
      videos: null,
      agenda: "More Details"
    },
    {
      id: 6,
      title: "ISUW 2020 | TRACK-4: TECHNOLOGIES ENABLING ENERGY TRANSITION: ENERGY STORAGE SYSTEMS (ESS)",
      description: `
        <p>This session discussed key topics related to battery energy storage systems requirements for integration of renewable energy into the grid.</p>
        <p><strong>Session 1:</strong></p>
        <ol>
          <li>Battery Technologies for Grid Storage and Electric Vehicles</li>
          <li>Energy Storage Systems Roadmap for India: 2019-2032</li>
        </ol>
        <p><strong>Tutors:</strong> Arumugam Manthiram (Director, Texas Materials Institute, The University of Texas, Austin, USA - On Video), Ravi Seethapathy (Chair of ISGF Working Group and Chairman, Biosirus Inc., Canada)</p>
        <p><strong>Session 2:</strong></p>
        <ol>
          <li>Manufacturing of Energy Storage Systems in India</li>
          <li>Value Streams and Business Case for Energy Storage: Impact of Power Market Design and Regulation</li>
          <li>Battery Requirements for Electric Mobility in India</li>
          <li>Storage Projects: International Best Practices and Lessons for India</li>
        </ol>
        <p><strong>Tutors:</strong> Rahul Walawalkar (President - India Energy Storage Alliance - IESA)</p>
      `,
      date: "03 MARCH 2020",
      location: "Hotel The Lalit, New Delhi",
      photos: "https://flic.kr/s/aHsmMi2G6y",
      videos: null,
      agenda: "More Details"
    },
    {
      id: 7,
      title: "ISUW 2019 | Theme 1: Energy Transition and Utility Transformation",
      description: `
        <p>A 360-degree in-depth review of business transformation triggered by the introduction of Smart Metering or AMI.</p>
        <p><strong>Topics:</strong></p>
        <ol>
          <li>AMI related Utility Transformation Real-world Experiences</li>
          <li>Cloud Strategies and Roadmap for Digital Utilities</li>
          <li>Advanced Grid Applications (Resiliency and Future Readiness, Digitalization and Asset Health)</li>
        </ol>
        <p><strong>Tutors:</strong> Anant Venkateswaran (Director, ISGF Master Classes, USA), Jonathan Pettit (Manager - AMS Program, Oncor Electric Delivery, USA), Randall Schmidt (Oncor Electric Delivery, USA), Nitin Kumar (Principal Cloud Architect, CloudKrest, USA), Rama Rao Bandireddy (Oracle Utilities, India), Suhas Dhapre (ISGF and formerly with Tata Power Company Ltd., Mumbai, India), Ajoy Rajani (Sr. Executive VP, AEML, India)</p>
      `,
      date: "12 March 2019",
      location: "Manekshaw Center, Delhi",
      photos: "https://flic.kr/s/aHsmCkNvPu",
      videos: null,
      agenda: "More Details"
    },
    {
      id: 8,
      title: "ISUW 2019 | Theme-2: Next Generation Technologies for Utility Transformation",
      description: `
        <p>Focus on IoT, AI, and Blockchain Technologies for utility transformation.</p>
        <p><strong>Topics:</strong></p>
        <ol>
          <li>Energy Blockchain Consortium Certified Champion Training Session (EBCCC)</li>
          <li>Next Generation Technologies for Utility Transformation (Artificial Intelligence, Analytics and Visualization, Asset Health Analytics)</li>
          <li>BOTs for Utilities</li>
          <li>Blockchain Applications for Energy Sector</li>
        </ol>
        <p><strong>Tutors:</strong> Chris Peoples (Energy Blockchain Consortium, USA), Marcus Bonner (GE, USA), Kartik Poddar (Haptik India), Lorien Gamaroff (CEO, Centbee, South Africa), Shrirang K. Karandikar (Energy Web Foundation, Germany), Reena Suri (General Manager, India Smart Grid Forum)</p>
      `,
      date: "12 March 2019",
      location: "Manekshaw Center, Delhi",
      photos: "https://flic.kr/s/aHsmC3mWRP",
      videos: null,
      agenda: "More Details"
    }
  ];

  React.useEffect(() => {
    // Try to fetch from API first, if fails use static data
    axios.get(url)
      .then((response) => {
        setMasterClasses(response.data);
      })
      .catch((error) => {
        console.log("Using static data for Master Classes");
        setMasterClasses(staticMasterClasses);
      });
  }, []);

  if (!getMasterClasses) return null;

  return (
    <>
      <section
        className="isgf-breadcum isgf_master_classes_breadcum"
        style={{
          backgroundImage: `url(${
            process.env.PUBLIC_URL +
            "/images/bilateral-workshops/bilateral-workshops-banner.jpg"
          })`,
        }}
      >
        <div className="container">
          <div className="isgf-breadcum-box">
            <h1>Master Classes</h1>
            <p>
              Home {">"} ISGF Initiatives {">"} Master Classes
            </p>
          </div>
        </div>
      </section>
      <section className="master-classes">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 ">
              <div className="row">
                <div className="col-md-12">
                  <div className="heading mb-3">
                    <h2>ISGF Master Classes</h2>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="benefits_membership master-classes-events">
                    <div className="mb-3">
                      <div className="isgf_accordion">
                        <div className="accordion" id="accordionExample">
                          {getMasterClasses &&
                            getMasterClasses.map((data, index) => (
                              <div className="accordion-item" key={data.id || index}>
                                <h2 className="accordion-header bg-green" id={`heading${index}`}>
                                  <button
                                    className="accordion-button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapseOne${index}`}
                                    aria-expanded="false"
                                    aria-controls={`collapseOne${index}`}
                                  >
                                    {data.title}
                                  </button>
                                </h2>
                                <div 
                                  id={`collapseOne${index}`} 
                                  className="accordion-collapse collapse p-3" 
                                  aria-expanded="false" 
                                  aria-labelledby={`heading${index}`} 
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="master-class-content">
                                    {parse(`${data.description}`)}
                                    
                                    <div className="row g-4 mt-4">
                                      {data.agenda && (
                                        <div className="col-md-3 col-lg">
                                          <div className="agenda-box text-center">
                                            <h4>Agenda</h4>
                                            <img
                                              src="images/woman-energy/agenda-icon-1.png"
                                              className="img-fluid"
                                              style={{ height: "45px" }}
                                              alt="Agenda"
                                            />
                                            {getAgendaHref(data) ? (
                                              <a
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                href={getAgendaHref(data)}
                                                className="btn btn-orange mt-3 p-2 d-block"
                                                download
                                              >
                                                Agenda
                                              </a>
                                            ) : (
                                              <div className="btn btn-orange mt-3 p-2 d-block">
                                                Agenda
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      )}

                                      {data.date && (
                                        <div className="col-md-3 col-lg">
                                          <div className="agenda-box text-center">
                                            <h4>Date</h4>
                                            <img
                                              src="images/woman-energy/agenda-icon-2.png"
                                              className="img-fluid"
                                              style={{ height: "45px" }}
                                              alt="Date"
                                            />
                                            <div className="btn btn-orange mb-0 mt-3 p-2 d-block">
                                              {data.date}
                                            </div>
                                          </div>
                                        </div>
                                      )}

                                      {data.location && (
                                        <div className="col-md-3 col-lg">
                                          <div className="agenda-box text-center">
                                            <h4>Location</h4>
                                            <img
                                              src="images/woman-energy/location.jpg"
                                              className="img-fluid"
                                              style={{ height: "45px" }}
                                              alt="Location"
                                            />
                                            <div className="btn btn-orange mb-0 mt-3 p-2 d-block">
                                              {data.location}
                                            </div>
                                          </div>
                                        </div>
                                      )}

                                      {data.photos && (
                                        <div className="col-md-3 col-lg">
                                          <div className="agenda-box text-center">
                                            <h4>View Photos</h4>
                                            <img
                                              src="images/woman-energy/agenda-icon-4.png"
                                              className="img-fluid"
                                              style={{ height: "45px" }}
                                              alt="Photos"
                                            />
                                            <a
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              href={data.photos}
                                              className="btn btn-orange mt-3 p-2 d-block"
                                            >
                                              View Photos
                                            </a>
                                          </div>
                                        </div>
                                      )}

                                      {data.videos && Array.isArray(data.videos) && data.videos.length > 0 && (
                                        <div className="col-md-3 col-lg">
                                          <div className="agenda-box text-center">
                                            <h4>Videos</h4>
                                            <img
                                              src="images/woman-energy/agenda-icon-3.png"
                                              className="img-fluid"
                                              style={{ height: "45px" }}
                                              alt="Videos"
                                            />
                                            {data.videos.map((video, videoIndex) => (
                                              <a
                                                key={videoIndex}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                href={video}
                                                className="btn btn-orange mt-3 p-2 d-block mb-2"
                                              >
                                                Video Part {videoIndex + 1}
                                              </a>
                                            ))}
                                          </div>
                                        </div>
                                      )}

                                      {data.videos && !Array.isArray(data.videos) && data.videos !== "Not Available" && (
                                        <div className="col-md-3 col-lg">
                                          <div className="agenda-box text-center">
                                            <h4>Videos</h4>
                                            <img
                                              src="images/woman-energy/agenda-icon-3.png"
                                              className="img-fluid"
                                              style={{ height: "45px" }}
                                              alt="Videos"
                                            />
                                            <a
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              href={data.videos}
                                              className="btn btn-orange mt-3 p-2 d-block"
                                            >
                                              View Recording
                                            </a>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <Sidebar />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default MasterClasses;